import { render, staticRenderFns } from "./DeleteModalTemplate.vue?vue&type=template&id=1c99e2de&scoped=true&"
import script from "./DeleteModalTemplate.vue?vue&type=script&lang=ts&"
export * from "./DeleteModalTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteModalTemplate.vue?vue&type=style&index=0&id=1c99e2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c99e2de",
  null
  
)

export default component.exports